import React from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function AboutSection() {
    useScrollAnimation();
    return (
        <section className="relative py-[40px]">
            <div className="main-title js-scroll fade-top ">
                <div>About us</div>
            </div>
            <div className="container f-col py-[20px] flex items-center gap-[20px] justify-between">
                <div className="d-none js-scroll fade-left w-[48%]">
                    <img className="w-[80%] h-full" src={require("../../assets/image/about_home.png")} alt="" />
                </div>
                <div className="ta-center w-100 w-[48%] flex flex-col gap-[20px]">
                    <div className="flex flex-col">
                        <span className="js-scroll fade-right text-[35px] text-[#294a6a] font-bold capitalize">M Power</span>
                        <span className="js-scroll fade-right text-[23px] font-bold capitalize">the best of moving services</span>
                    </div>
                    <p className="js-scroll fade-right">
                        M Power Moving Services, no job is too big or too small.
                        What began as a small local moving service has grown into a
                        trusted name for both local and long-distance moves across the
                        U.S. With our expertise, commitment, and top-tier resources,
                        we ensure every move is smooth, efficient, and stress-free.
                    </p>
                    <Link to={"/about"} className="js-scroll fade-right w-fit bg-[#294a6a] text-white py-[6px] px-[20px] rounded-[4px]">Read More</Link>
                </div>
            </div>
        </section>
    );
}